/* eslint-disable react/prop-types */

import Image from "next/image";
import Link from "next/link";
import { sanitize, adjustColor  } from '@/utils/misc';
import studioStore from '@/stores/studioStore';

function CTA({sectionImage, sectionLink, backgroundColor = "#ffffff", sectionContainer, sectionTitle, sectionText, sectionButtonText, ctaBackgroundColor}) {
  const primaryColor = studioStore.settings.colors.primary_color;
  const hoverPrimaryColor = adjustColor(primaryColor, -30);
  let classes = "w-full h-full";
  const style = {
    backgroundColor: ctaBackgroundColor,
  };

  if (sectionContainer === "stamp") {
    classes = "stamp-border w-[calc(100%+2rem)] h-[calc(100%+2rem)] -m-[1rem]";
    style.backgroundImage = `radial-gradient(8px, transparent 98%, ${ctaBackgroundColor}),linear-gradient(${ctaBackgroundColor} 0px, ${ctaBackgroundColor} 0px)`;
    style.backgroundColor = '';
    style.color = primaryColor;
  }
  return (
    <div className="section-cta py-4 md:py-8" style={{backgroundColor: backgroundColor}}>
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row overflow-hidden">
          <div className="w-full md:w-1/2">
            <div
              style={{
                width: `${sectionImage.width}px`,
                height: "100%",
                minHeight: `200px`,
                maxWidth: "100%",
                overflow: "hidden",
                position: "relative",
              }}
              className="mx-auto"
            >
              <Link href={sectionLink}>
                <Image
                  src={sectionImage?.url || "/images/no-image.jpg"}
                  alt={sectionImage?.alt || "No image available"}
                  title={sectionImage.title || "Product image"}
                  fill
                  sizes={`(max-width: 768px) 100vw, (max-width: 1200px) 50vw, ${sectionImage.width}px`}
                  style={{ objectFit: "cover" }}
                  onError={(e) => {
                    e.target.src = "/images/no-image.jpg";
                  }}
                />
              </Link>
            </div>
          </div>
          <div className="w-full md:w-1/2 z-10">
            <div className={classes} style={style}>
              <div className="cta-content px-12 lg:px-32 py-6 lg:py-16">
                <h3 className="text-3xl md:text-4xl 2xl:text-6xl mb-3 md:mb-4 2xl:mb-7 font-secondary" dangerouslySetInnerHTML={{ __html: sanitize(sectionTitle)}} />
                <h4 className="text-xl md:text-2xl 2xl:text-4xl font-medium mb-4 md:mb-5 2xl:mb-7" dangerouslySetInnerHTML={{ __html: sanitize(sectionText)}} />
                <Link href={sectionLink}>
                  <button className="cta-button text-white py-2 px-4 rounded-xl transition duration-300 font-secondary">
                    {sectionButtonText}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .cta-button {
          background-color: ${primaryColor}
        }
        .cta-button:hover {
          background-color: ${hoverPrimaryColor};
        }
      `}</style>
    </div>
  )
}

export default CTA